import type { FiatPrice, Prices } from "@b2bportal/core-types";

export interface CalculatePerUnitPriceOptions {
  totalPrice: Prices;
  unitCount: number;
  rewardsAccountId?: string;
}

/**
 * Divides a total price by a unit count (passengers, days, etc.)
 * Rounds up to ensure per-unit * count >= total (avoids displaying $99 total with $33/person × 3)
 */
export const calculatePerUnitPrice = ({
  totalPrice,
  unitCount,
  rewardsAccountId,
}: CalculatePerUnitPriceOptions): Prices => {
  const perUnitFiatPrice: FiatPrice = {
    ...totalPrice.fiat,
    value: Math.ceil(totalPrice.fiat.value / unitCount),
  };

  const accountSpecificPrice =
    rewardsAccountId != null
      ? totalPrice.accountSpecific?.[rewardsAccountId]
      : undefined;

  const perUnitPointsPrice = accountSpecificPrice
    ? {
        ...accountSpecificPrice,
        value: Math.ceil(accountSpecificPrice.value / unitCount),
      }
    : undefined;

  return {
    fiat: perUnitFiatPrice,
    accountSpecific:
      rewardsAccountId != null && perUnitPointsPrice
        ? { [rewardsAccountId]: perUnitPointsPrice }
        : {},
  };
};
